import { render } from "./MessageHeader.vue.js?vue&type=template&id=f37c9dc2&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageHeader.vue?vue&type=template&id=f37c9dc2&scoped=true"
import script from "./MessageHeader.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageHeader.vue?vue&type=script&lang=js"
export * from "./MessageHeader.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageHeader.vue?vue&type=script&lang=js"

import "./MessageHeader.vue.scss?vue&type=style&index=0&id=f37c9dc2&lang=scss&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageHeader.vue?vue&type=style&index=0&id=f37c9dc2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37c9dc2"],['__file',"src/SharedWeb/scripts/apps/conversations/components/message/MessageHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f37c9dc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f37c9dc2', __exports__)) {
    api.reload('f37c9dc2', __exports__)
  }
  
  module.hot.accept("./MessageHeader.vue.js?vue&type=template&id=f37c9dc2&scoped=true!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./MessageHeader.vue?vue&type=template&id=f37c9dc2&scoped=true", () => {
    api.rerender('f37c9dc2', render)
  })

}


export default __exports__